<script>
  import { fade } from "svelte/transition";
	import Load from "../components/Load.svelte" 
  import Alert from "../components/Alert.svelte";
  import Title from "../components/Title.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import ProfileCard from "../components/ProfileCard.svelte";

  //liblary
  import axios from "axios";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = []; 

  let items = [];
  let itemsDisplay = false;

  axios
    .get(settings.url + "/sipade/produk/1/a", {
      params: {
        authorization: settings.token,
      },
    })
    .then(function (response) {
      items = response.data;
      
      if (response.data) {
        setTimeout(() => {
          itemsDisplay = true;
        }, 2000);
      }
    })
    .catch(function (error) {
      
      itemsDisplay = false;
      if (error.response.status == 401) {
        localStorage.removeItem("t");
        redirect("/login");
      } else {
        if (error.response.data.message) {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: error.response.data.message,
              color: "orange",
            },
          ];
        } else {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: "Anda belum terhubung dengan baik",
              color: "orange",
            },
          ];
        }
      }
    })
    .then(function () {
      // always executed
    });
  let uid = Math.random().toString(36).substring(2);
</script>
<svelte:head>
<title>RukunPoints - Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<Navigationbar
  backbtn="true"
  title="RukunPoints"
  message={navigation['message']} />
<main transition:fade class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0">
  <div class="max-w-6xl pt-2 mx-auto lg:my-0">
    {#if itemsDisplay}
      <div
        class="flex flex-wrap items-center max-w-6xl pt-3 mx-auto mt-5 lg:my-0 ">
        <!--Main Col-->
        <ProfileCard/>
        <!--Img Col-->
        <div class="w-full mt-5 lg:w-2/4 lg:mt-auto md:mt-auto">
          <div
            class="relative p-5 mx-0 my-5 bg-gray-200 rounded-lg lg:bg-gray-100 md:bg-gray-100 lg:rounded-l-none lg:block lg:my-3">
            <Title
              subtitle="Kumpulkan poin dan tukarkan dengan berbagai produk"
              title="RukunPoints" />
            <p class="px-2">
              <b>RukunPoints</b>
              adalah reward berupa poin yang kami berikan kepada pengguna, poin
              tersebut bisa didapatkan melalui berbagai macam cara dan dapat
              ditukar dengan layanan atau produk yang tersedia dibawah ini
            </p>
          </div>
        </div>
      </div>
      {#if items.layanan}
        {#each items.layanan as l}
          <Title subtitle="Kumpulkan Poin melalui {l.label}" title={l.label} />
          {#each l.prod as json}
            <a
              href="/"
              class="relative block px-3 py-3 my-2 text-sm bg-white border-b border-gray-300 border-solid rounded-lg shadow-md hover:bg-white hover:shadow-xl">
              <div
                class="items-center justify-between text-sm lg:flex md:flex lg:text-base md:text-sm">
                <div class="font-semibold text-gray-700">
                  <span>{json.layanan}</span>
                </div>
                <div class="text-gray-700">
                  <span
                    class="text-sm font-light rounded-lg lg:px-2 lg:bg-green-200 md:px-2 md:bg-green-200">
                    {l.label}
                  </span>
                </div>
              </div>
              <div
                class="flex items-center justify-between text-sm lg:text-base md:text-sm lg:w-1/2 md:w-1/2">
                <div class="text-base text-gray-700 ">
                  <small>Keterangan</small><br />
                  {json.keterangan}
                </div>
                <div
                  class="text-sm text-gray-700 lg:text-base md:text-sm">
                  <small>RukunPoints</small>
                  <br />
                  <span
                    class="font-semibold text-green-400 hover:text-gray-700">
                    {#if json.tambahan}
                      <span
                        class="col-grey"
                        style="text-decoration: line-through;">
                        {json.harga}
                      </span>
                      <br />
                      <span>{json.harga_plus}</span>
                    {:else}{json.harga}{/if}/{json.satuan}
                  </span>
                </div>
              </div>
            </a>
          {/each}
        {/each}
      {:else}
        <p
          class="w-full p-5 mt-10 font-light text-center text-gray-500 bg-white rounded shadow-md">
          Belum ada layanan yang tersedia
        </p>
      {/if}
    {:else}
    <Load/>
    {/if}
  </div>
</main>
